import { ILocationContentfulData } from "../../services/contentful-service/contentful.interface";
import { actionTypes } from "./contentfulData.actions";


const initialState: ILocationContentfulData | null = null;

export const contentfulDataReducer = (
  state: ILocationContentfulData | null = initialState,
  action: { type: string, payload: ILocationContentfulData },
) => {
  switch (action.type) {
  case actionTypes.SET_CONTENTFUL_DATA:
    return action.payload;
  default:
    return state;
  }
};
